module.exports = __webpack_public_path__ + "img/stock3.51c7944e.png";